// extracted by mini-css-extract-plugin
export default {"informationTooltipIcon":"LzjLFs5dOuRhhrunppZR"};